import {
  AtSkeleton,
  formatDate,
  MlTableMessage,
} from "@csc-dashboard/components-library";
import { useAdminPanel } from "../context/admin-panel";

export const ClientContainer = () => {
  const { isGuest, userInfo } = useAdminPanel();

  if (isGuest) {
    return (
      <MlTableMessage
        darkerDescription
        size="mini"
        title="Estás navegando en modo anónimo"
        description="No hay información del cliente que podamos mostrar."
      />
    );
  }

  const { name, email, birthDay, gender, registeredAt } = userInfo || {};

  return (
    <div className="flex flex-col gap-4">
      <ClientInfo title="Nombre" content={name || ""} />
      <ClientInfo title="Correo electrónico" content={email || ""} />
      <ClientInfo
        title="Fecha de nacimiento"
        content={birthDay ? formatDate(birthDay, "D [de] MMMM [de] YYYY") : ""}
      />
      <ClientInfo title="Sexo" content={gender || ""} />
      <ClientInfo
        title="Registro"
        content={
          registeredAt ? formatDate(registeredAt, "D [de] MMMM [de] YYYY") : ""
        }
      />
    </div>
  );
};

const ClientInfo = ({ title, content }: { title: string; content: string }) => {
  const { isloadingUserInfo } = useAdminPanel();

  return (
    <div className="flex flex-col gap-2 text-normal text-surface-500">
      <p className="font-semibold">{title}</p>
      {isloadingUserInfo ? (
        <AtSkeleton variant="text" width={200} height={20} />
      ) : (
        <p className="text-sm">{content}</p>
      )}
    </div>
  );
};
